// src/store/globalStore.js
import { reactive } from "vue";

const STORAGE_KEY = "globalStore";

const loadInitialState = () => {
  try {
    const storedData = localStorage.getItem(STORAGE_KEY);
    return storedData ? JSON.parse(storedData) : {};
  } catch (error) {
    console.error("Failed to load initial state from localStorage", error);
    return {};
  }
};

const state = reactive({
  ...loadInitialState(),
});

const saveState = () => {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(state));
  } catch (error) {
    console.error("Failed to save state to localStorage", error);
  }
};

const get = (key) => state[key];

const set = (key, value) => {
  state[key] = value;
  saveState();
};

const remove = (key) => {
  delete state[key];
  saveState();
};

const clear = () => {
  Object.keys(state).forEach((key) => delete state[key]);
  saveState();
};

// 导出为插件
export default {
  install(app) {
    app.config.globalProperties.$store = {
      state,
      get,
      set,
      remove,
      clear,
    };
  },
};
